import { css } from '@linaria/core';
export const buttonGroup = "omponents__deprecated__Button__ButtonGroup_styles_ts-buttonGroup-b18lkfwp";

require("./ButtonGroup.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ButtonGroup.styles.ts");